import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';

import {AuthService} from './auth.service';
import {ConfigService} from './config.service';
import {LogService} from './log.service';


@Injectable()
export class ReviewerReviewService {
	constructor(
		private http: Http,

		private authService: AuthService,
		private config: ConfigService,
		private log: LogService
	) {}


	getAllReviews() {
		return new Promise((resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/reviews', options)
				.toPromise()
				.then((res: any) => {
					let resJson = res.json();

					let reviews: any = [];
					if (resJson.allReviews && resJson.allReviews.reviews) {
						reviews = resJson.allReviews.reviews;
					}
/*
					let sortedFilms = foo.allFilms.films.sort((a: any, b: any) => {

						if (a.title.toLowerCase() === b.title.toLowerCase()) {
							return 0;
						}
						if (a.title.toLowerCase() < b.title.toLowerCase()) {
							return -1;
						}
						return 1;


						// if (a.sortSubmissionId === b.sortSubmissionId) {
						// 	return 0;
						// }
						// if (a.sortSubmissionId < b.sortSubmissionId) {
						// 	return -1;
						// }
						// return 1;
					});
					foo.allFilms.films = sortedFilms;
*/
					resolve(reviews);
				})
				.catch((err: any) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
				});
		});
	}


	getUserReviews() {
		return new Promise((resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			let userId = this.authService.userId;
			this.http.get(this.config.basePath + '/v0/reviews/users/' + userId, options)
				.toPromise()
				.then((res: any) => {
					let resJson = res.json();

					let reviews: any = [];
					if (resJson.userReviews && resJson.userReviews.reviews) {
						reviews = resJson.userReviews.reviews;
					}
/*
					let sortedFilms = foo.allFilms.films.sort((a: any, b: any) => {


						if (a.title.toLowerCase() === b.title.toLowerCase()) {
							return 0;
						}
						if (a.title.toLowerCase() < b.title.toLowerCase()) {
							return -1;
						}
						return 1;


						// if (a.sortSubmissionId === b.sortSubmissionId) {
						// 	return 0;
						// }
						// if (a.sortSubmissionId < b.sortSubmissionId) {
						// 	return -1;
						// }
						// return 1;
					});
					foo.allFilms.films = sortedFilms;
*/
					resolve(reviews);
				})
				.catch((err: any) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
				});
		});
	}

/*
	getUserReviewingReview() {
		return new Promise((resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			let userId = this.authService.userId;
			this.http.get(this.config.basePath + '/v0/reviews/users/' + userId, options)
				.toPromise()
				.then((res: any) => {
					let resJson = res.json();

					let reviewingReview: any = {};
					if (resJson.userReviews && resJson.userReviews.reviewingReview) {
						reviewingReview = resJson.userReviews.reviewingReview;
					}
					resolve(reviewingReview);
				})
				.catch((err: any) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
				});
		});
	}
*/

	updateReview(reviewUpdates: any) {
		return new Promise((resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });
			let payload = reviewUpdates;
			let body = JSON.stringify(payload);

			let userId = this.authService.userId;
			this.http.put(this.config.basePath + '/v0/reviews/users/' + userId, body, options)
				.toPromise()
				.then((res: any) => {
					// let foo = res.json();
					resolve();
				})
				.catch((err: any) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}


	createReview(reviewPayload: any) {
		return new Promise((resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });
			let payload = reviewPayload;
			let body = JSON.stringify(payload);

			let userId = this.authService.userId;
			this.http.post(this.config.basePath + '/v0/reviews/users/' + userId, body, options)
				.toPromise()
				.then((res: any) => {
					// let foo = res.json();
					resolve();
				})
				.catch((err: any) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/reviewer-review.service.ts